// removed by extract-text-webpack-plugin
module.exports = {"container":"_2brQxMVUdmd4Rn29x9u4Lm","button":"_6_mVE1AqWEJjoqpyDiq1Q","icon1":"_2RE3562mzmjlkmhdxOb7rG","icon2":"_23UPIz87IAAemzCtFbgVGu","icon3":"_2TTkWmmyP1GwYKG1pGiAP"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/OwnArchivedDocuments/styles.css
// module id = 2726
// module chunks = 0